import React from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faCopy, faPencil, faPieChart } from '~components/icon';
import ExportBudgetToPDF from '~support-at-home/components/budgets/export-to-pdf/ExportBudgetToPDF';

import { User } from '~main/reducers/login';

interface ComponentProps {
  id: string;
  reference: string;
  openEdit: (id: string) => void;
  openTracker: (id: string) => void;
  openCopy?: (id: string) => void;
  user?: User;
  disabled?: boolean;
}

const ActionButtons: React.FC<ComponentProps> = ({
  id,
  openEdit,
  openTracker,
  openCopy,
  disabled = false,
}) => {
  return (
    <div className="d-flex justify-content-end align-items-center gap-2">
      <ExportBudgetToPDF id={id} />
      <ClickableIcon
        id={`${id}-edit`}
        icon={faPencil}
        onClick={() => openEdit(id)}
        toolTip="Edit"
        disabled={disabled}
      />
      {openCopy && (
        <ClickableIcon
          id={`${id}-copy`}
          icon={faCopy}
          onClick={() => openCopy(id)}
          toolTip="Copy"
          disabled={disabled}
        />
      )}
      <ClickableIcon
        id={`${id}-tracker`}
        icon={faPieChart}
        onClick={() => openTracker(id)}
        toolTip="Tracker"
        disabled={disabled}
      />
    </div>
  );
};

export default ActionButtons;
